import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { SiGmail, SiWakatime } from 'react-icons/si';
import {HiOutlineDocumentText} from 'react-icons/hi';
import './SocialMedia.scss';

const SocialMedia = () => (
	<div className="app__social">
		
		<a href="https://www.linkedin.com/in/felipe-p-315b691ba">
			<div>
				<BsLinkedin />
			</div>
		</a>
		<a href="mailto:fpovinamigliavacca@gmail.com">
			<div>
				<SiGmail />
			</div>
		</a>
		<a href="https://wakatime.com/@pip_po">
			<div>
				<SiWakatime />
			</div>
		</a>
    <a href="https://drive.google.com/file/d/1Hrpj1t0l_XhXW07XY8asOQotS2zLu3rC/view?usp=sharing" target="_blank" rel="noreferrer">
			<div className="resume">
				<HiOutlineDocumentText />
			</div>
		</a>
	</div>
);

export default SocialMedia;
